/**
 * Роутер платформенной зоны. Структура повторяет реестр DOMAINS
 * (routes/domains.ts). Страницы сейчас — плейсхолдеры (design pending),
 * заменяются реальными экранами по мере готовности дизайна.
 */

import {Navigate, Route, Routes} from 'react-router-dom';

import {Accounts} from '@pages/Accounts';
import {Applications} from '@pages/Applications';
import {AppShell} from '@pages/AppShell';
import {Audit} from '@pages/Audit';
import {ChangePassword} from '@pages/ChangePassword';
import {Clients} from '@pages/Clients';
import {Dashboard} from '@pages/Dashboard';
import {ForgotPassword} from '@pages/ForgotPassword';
import {Login} from '@pages/Login';
import {NotFound} from '@pages/NotFound';
import {Payments} from '@pages/Payments';
import {Reports} from '@pages/Reports';
import {System} from '@pages/System';
import {Tariffs} from '@pages/Tariffs';
import {Usage} from '@pages/Usage';

import {TeamPublicRoute, TeamRoute} from './ProtectedRoute';

export const AppRouter = () => (
  <Routes>
    <Route element={<TeamPublicRoute />}>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
    </Route>

    {/* Клиентский контур: онбординг (вход = регистрация) + first-run настройка */}

    <Route element={<TeamRoute />}>
      <Route path="/change-password" element={<ChangePassword />} />
      <Route element={<AppShell />}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/accounts" element={<Accounts />} />
        <Route path="/applications" element={<Applications />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/usage" element={<Usage />} />
        <Route path="/tariffs" element={<Tariffs />} />
        <Route path="/payments" element={<Payments />} />
        <Route path="/system" element={<System />} />
        <Route path="/audit" element={<Audit />} />
      </Route>
    </Route>

    <Route path="*" element={<NotFound />} />
  </Routes>
);
